"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AppBarTitle = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var _Styling = require("@fluentui/react/lib/Styling");

var React = _interopRequireWildcard(require("react"));

var _AppBarTitle = require("./AppBarTitle.classNames");

var _dec, _class;

var AppBarTitle = (_dec = (0, _react.customizable)('AppBar', ['theme']), _dec(_class = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AppBarTitle, _React$Component);

  var _super = (0, _createSuper2.default)(AppBarTitle);

  function AppBarTitle() {
    (0, _classCallCheck2.default)(this, AppBarTitle);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(AppBarTitle, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var theme = this.props.theme || (0, _Styling.getTheme)();
      var classNames = (0, _AppBarTitle.getClassNames)(theme);
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _react.css)('ms-AppBarTitle', classNames.root),
        children: children
      });
    }
  }]);
  return AppBarTitle;
}(React.Component)) || _class);
exports.AppBarTitle = AppBarTitle;